export const colors = {
    primary: '#2c89cf',
    secondary: '#747474',
    accent: '#025796',
    error: '#f24f4f',
    info: '#2196F3',
    success: '#49BF77',
    warning: '#FECF32',
    lines: '#EAF0F5',
    lightGrey: '#C6C6C6',
};
